module.exports = __webpack_public_path__ + "img/edit_header.96039a4c.svg";